// extracted by mini-css-extract-plugin
export default {"page":"register-page_page__SwqWa","form":"register-page_form__rXLzs"};